export function injectTemplateFields(
  template: string = '',
  fields?: (string | { key: string })[],
  row: Record<string, any> = {}
): string {
  let result = template;

  if (!fields || !Array.isArray(fields)) return result;

  fields.forEach((field) => {
    const key = typeof field === 'string' ? field : field?.key;
    if (!key) return;

    const value = row?.[key];

    // If value is nullish or empty string, remove the placeholder entirely
    const finalValue = value === null || value === undefined || value === '' ? '' : value;

    const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
    result = result.replace(regex, finalValue);
  });

  // Finally, remove any remaining {{ unknown_field }} patterns
  result = result.replace(/{{\s*[\w.]+\s*}}/g, '');

  return result;
}
